import * as CONST from "./actionTypes";

export const getQuoteList = (data, callback) => ({
  type: CONST.GET_QUOTE_LIST,
  payload: {data, callback},
});

export const getQuoteListSuccess = (data) => ({
  type: CONST.GET_QUOTE_LIST_SUCCESS,
  payload: data,
});

export const getQuoteListFail = (error) => ({
  type: CONST.GET_QUOTE_LIST_FAIL,
  payload: error,
});



export const createTransaction = (data, callback) => ({
  type: CONST.CREATE_TRANSACTION,
  payload: {data, callback},
});

export const createTransactionSuccess = (data) => ({
  type: CONST.CREATE_TRANSACTION_SUCCESS,
  payload: data,
});

export const createTransactionFail = (error) => ({
  type: CONST.CREATE_TRANSACTION_FAIL,
  payload: error,
});


